module.exports = __webpack_public_path__ + "static/img/Sin-Heng_Wang.jpg";